import TextEditor from "components/commons/text-editor";
import moment from "moment";
import Datepicker from "../../commons/datepicker";
import FormModal from "../../commons/form-modal";
import Input from "../../commons/input";
import ErrorMessage from "components/commons/error-message";

export const EventForm = (
    {
        title,
        show,
        onHide,
        eventDetail = {},
        onChangeValue,
        errorForm,
        isCreating,
        isUpdating,
        onSubmitForm
    }) => {

    return (
        <FormModal
            title={title}
            show={show}
            width={'max-w-[1024px]'}
            onHide={onHide}
            isLoading={isCreating || isUpdating}
            onSubmitForm={onSubmitForm}
        >
            <div className={"flex flex-col space-y-6 px-6 pt-8 pb-16"}>
                <div className={"flex items-center text-neutral-70"}>
                    <div className={"w-1/4 required"}>Tanggal Event</div>
                    <div className="flex-1">
                        <Datepicker
                            className="flex-1"
                            value={eventDetail?.date}
                            format='YYYY-MM-DD'
                            minDate={moment()}
                            maxDate={`${moment().get('year') + 2}-12-31`}
                            onChange={(e) => onChangeValue(e, 'date')}
                        />
                        <ErrorMessage className="mt-2" message={errorForm?.date}/>
                    </div>
                </div>
                <div className={"flex items-center text-neutral-70"}>
                    <div className={"w-1/4 required"}>Judul Event</div>
                    <div className="flex-1">
                        <Input className="flex-1" name="name" placeholder="Isi judul event" value={eventDetail?.name}
                            onChange={(e) => onChangeValue(e)}/>
                        <ErrorMessage className="mt-2" message={errorForm?.name}/>
                    </div>
                </div>
                <div className={"flex items-center text-neutral-70"}>
                    <div className={"w-1/4"}>Deskripsi</div>
                    <TextEditor
                        className={'h-44'}
                        useLink
                        defaultValue={eventDetail?.description}
                        onChange={(val) => onChangeValue({name: "description", value: val})}
                        placeholder="Isi deskripsi event"
                    />
                </div>
            </div>
        </FormModal>
    )
}
